import AAutoComplete from './a-auto-complete.vue'

export default AAutoComplete
